import { combineReducers } from '@reduxjs/toolkit'
import { authApi } from '@/features/auth/auth.api.ts'
import { authSlice } from '@/features/auth/auth.slice.ts'
import { documentAutofillApi } from '@/features/document-autofill/document-autofill.api.ts'
import { checklistApi } from '@/features/checklist/checklist.api.ts'
import { headcountApi } from '@/features/headcount/headcount.api.ts'
import { portalConfigurationApi } from '@/features/portal-configuration/portal-configuration.api.ts'
import { appraisalApi } from '@/features/appraisal/appraisal.api.ts'
import { userApi } from '@/features/user/user.api.ts'
import { employeeDataApi } from '@/features/employee-data/employee-data.api.ts'
import { rewardExerciseApi } from '@/features/reward-exercise/reward-exercise.api.ts'
import { timeOffApi } from '@/features/time-off/time-off.api.ts'
import { enumApi } from '@/features/employee-data/enumApi.ts'
import { onboardingApi } from '@/features/onboarding/onboarding.api.ts'
import { offboardingApi } from "@/features/offboarding/offboarding.api.ts";
import { probationApi } from '@/features/probation/probation.api.ts'
import { promotionApi } from '@/features/promotion/promotion.api.ts'
import { overtimeApi } from '@/features/overtime/overtime.api.ts'
import { teamApi } from '@/features/team/team.api.ts'

export const appReducer = combineReducers({
  [enumApi.reducerPath]: enumApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [documentAutofillApi.reducerPath]: documentAutofillApi.reducer,
  [employeeDataApi.reducerPath]: employeeDataApi.reducer,
  [checklistApi.reducerPath]: checklistApi.reducer,
  [appraisalApi.reducerPath]: appraisalApi.reducer,
  [headcountApi.reducerPath]: headcountApi.reducer,
  [portalConfigurationApi.reducerPath]: portalConfigurationApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [rewardExerciseApi.reducerPath]: rewardExerciseApi.reducer,
  [timeOffApi.reducerPath]: timeOffApi.reducer,
  [onboardingApi.reducerPath]: onboardingApi.reducer,
  [offboardingApi.reducerPath]: offboardingApi.reducer,
  [probationApi.reducerPath]: probationApi.reducer,
  [promotionApi.reducerPath]: promotionApi.reducer,
  [overtimeApi.reducerPath]: overtimeApi.reducer,
  [teamApi.reducerPath]: teamApi.reducer,
  auth: authSlice.reducer,
})
